import { Injectable, Injector } from '@angular/core';
import { MapToServerSideEnum } from 'src/core/decorators/enum/mapto-server-side-enum.decorator';
import { ServerSideEnum } from './server-side-enum.model';

@Injectable({
  providedIn: 'root',
})
@MapToServerSideEnum('PrivacyType')
export class PrivacyType extends ServerSideEnum {
  Public: number;
  Private: number;

  constructor(injector: Injector) {
    super(injector);
  }
}
